import { Avatar, Paper, Typography } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { getFilesArchivos } from '../../../archivos/HelpersArchivos';

const CardEstudianteNotasBlopedComponent = () => {
  const estudiantesStore = Redux.useSelector((state) => state.estudiantes);

  return (
    <Paper elevation={4} sx={{ p: 2 }}>
      <Avatar
        alt={estudiantesStore.activo.usuario.perfil.pnombre}
        sx={{ width: 150, height: 150 }}
        src={getFilesArchivos(estudiantesStore.activo.usuario.perfil.avatar)}
      />
      <Typography variant="h6">
        {estudiantesStore.activo.usuario.perfil.pnombre}
        {estudiantesStore.activo.usuario.perfil.papellido}
      </Typography>
      <Typography variant="h6">
        {estudiantesStore.activo.usuario.perfil.dni}
      </Typography>
    </Paper>
  );
};

export default CardEstudianteNotasBlopedComponent;
